import React, { useState } from "react";
import "./PolitiquePage.css";
import Logo from "./Logo.png";

const PolitiquePage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"confidentialite" | "conditions">(
    "confidentialite"
  );

  return (
    <>
            <div className="barupcontact">
        <h4>Wyn.ma</h4>
    </div>
    <div className="policy-container-cnvi">
      {/* 🔹 Tabs */}
      <div className="tabs-cnvi">
        <button
          className={activeTab === "confidentialite" ? "active-cnvi" : ""}
          onClick={() => setActiveTab("confidentialite")}
        >
          Politique de Confidentialité
        </button>
        <button
          className={activeTab === "conditions" ? "active-cnvi" : ""}
          onClick={() => setActiveTab("conditions")}
        >
          Conditions Générales
        </button>
      </div>

      {/* 🔹 Content */}
      <div className="policy-card-cnvi">
        {activeTab === "confidentialite" && (
          <div className="policy-content-cnvi">
            <h3>Introduction</h3>
            <p>
              Cette Politique de Confidentialité explique comment nous collectons,
              utilisons et protégeons vos données personnelles lorsque vous
              utilisez notre site <strong>CHABAKAT AL NAML, SARL</strong>.
            </p>

            <h3>1. Données collectées</h3>
            <p>
              <strong>Données d’identification :</strong> nom, prénom, adresse email,
              numéro de téléphone.
            </p>
            <p>
              <strong>Données de navigation :</strong> adresse IP, navigateur, pages
              consultées.
            </p>

            <h3>2. Utilisation des données personnelles</h3>
            <ul>
              <li>Fournir nos services et gérer les commandes</li>
              <li>Envoyer des notifications liées aux services</li>
              <li>Améliorer l’expérience utilisateur</li>
              <li>Respecter nos obligations légales</li>
            </ul>

            <h3>3. Partage des données</h3>
            <p>
              Vos données peuvent être partagées uniquement avec nos partenaires de
              confiance et prestataires techniques nécessaires au bon
              fonctionnement du service.
            </p>

            <h3>4. Hébergement des données</h3>
            <p>
              Les données sont hébergées sur des serveurs sécurisés situés au Maroc
              et dans l’Union Européenne.
            </p>

            <h3>5. Droits des utilisateurs</h3>
            <ul>
              <li>Droit d’accès</li>
              <li>Droit de rectification</li>
              <li>Droit d’opposition</li>
              <li>Droit à l’effacement</li>
            </ul>

            <h3>6. Sécurité des données</h3>
            <p>
              Nous mettons en place des mesures de sécurité techniques et
              organisationnelles pour protéger vos informations personnelles.
            </p>

            <h3>7. Modifications de la politique</h3>
            <p>
              Nous nous réservons le droit de modifier cette politique. Toute
              modification sera publiée sur cette page.
            </p>
          </div>
        )}

        {activeTab === "conditions" && (
          <div className="policy-content-cnvi">
            <h3>Article 1 – Introduction</h3>
            <p>
              En accédant au site, vous acceptez sans réserve les présentes
              Conditions Générales d’Utilisation (CGU).
            </p>

            <h3>Article 2 – Modification des CGU</h3>
            <p>
              Nous nous réservons le droit de modifier ces CGU à tout moment. Les
              modifications prendront effet dès leur publication.
            </p>

            <h3>Article 3 – Disponibilité du Site</h3>
            <p>
              Nous nous efforçons de maintenir l’accès au site en continu, mais nous
              ne garantissons pas son fonctionnement sans interruption.
            </p>

            <h3>Article 4 – Utilisation du Site</h3>
            <p>
              Vous vous engagez à utiliser le site conformément à la loi, aux bonnes
              mœurs et à ne pas porter atteinte aux droits de tiers.
            </p>

            <h3>Article 5 – Éditeur du Site</h3>
            <p>
              Le site est édité par la société CHABAKAT AL NAML, SARL, dont le siège
              est basé au Maroc.
            </p>

            <h3>Article 6 – Propriété intellectuelle</h3>
            <p>
              Tous les contenus présents sur le site sont protégés par le droit
              d’auteur et la propriété intellectuelle.
            </p>

            <h3>Article 7 – Responsabilité de l’utilisateur</h3>
            <p>
              L’utilisateur est responsable de l’utilisation qu’il fait du site et
              des informations qu’il y saisit.
            </p>

            <h3>Article 8 – Responsabilité de l’éditeur</h3>
            <p>
              L’éditeur ne peut être tenu responsable en cas de mauvaise utilisation
              du site ou de dommages liés à l’accès au site.
            </p>

            <h3>Article 9 – Protection des données personnelles</h3>
            <p>
              Les données personnelles collectées font l’objet d’un traitement
              conforme à notre Politique de Confidentialité.
            </p>

            <h3>Article 10 – Liens externes</h3>
            <p>
              Le site peut contenir des liens vers d’autres sites. Nous ne sommes pas
              responsables de leur contenu ni de leur politique de confidentialité.
            </p>

            <h3>Article 11 – Modération des messages et devis</h3>
            <p>
              Nous nous réservons le droit de modérer ou supprimer tout message ou
              contenu non conforme aux lois en vigueur ou aux règles de bonne
              conduite.
            </p>
            <h3>Article 12 – Loi applicable et juridiction</h3>
            <p>
              Ces CGU sont régies par la loi marocaine. Les litiges relèvent de la compétence des tribunaux marocains.
La gestion des données est déclarée auprès de la CNDP sous le numéro D-925/2024. Pour exercer vos droits : contact@wyn.ma.
            </p>
          </div>
        )}
      </div>
    </div>
            <div className="footer-contacte">
        <div>
            <p style={{fontFamily:"lato"}}> Avec plus de 30.000 références en stock, et le rapport le plus détaillé des spécifications de fabrication de tous ses produits, Wyn met à la disposition de ses clients le meilleur service du secteur en pièces et en composants</p>
            <img src={Logo} alt="" />
        </div>
        <div >
            <h3 className="mb-4">pages</h3>
            <h4>Accueille</h4>
            <h4>Voir les articles</h4>
            <h4>Rechercher un articles</h4>
            <h4>Connecter comme visiteur</h4>
            <h4>Politique de confidentialité</h4>

        </div>
        <div>
            <h3 className="mb-4">Contactez Nous sur : </h3>
            <p><i className="bi bi-pin-map-fill"></i>Imm Lotf-Allah Angle Bd La Grande Ceinture et <br />
            Ibn Al Adraa Al Morrakochi Casablanca</p>
            <p><i className="bi bi-whatsapp"></i>+212 693-693694</p>
            <p><i className="bi bi-envelope-paper"></i>Contact@wyn.ma</p>

        </div>
    </div>
    </>
  );
};

export default PolitiquePage;
